<template>
    <card>
       <template slot="header">
          <h3 class="card-title">New Calendar Event</h3>
       </template>
       <nav class="row">
          <ol class="breadcrumb  arr-right bg-breadcrum">
             <li class="breadcrumb-item">
                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
             </li>
             <li class="breadcrumb-item">
                <router-link to="holidays">Calendar Event</router-link>
             </li>
             <li class="breadcrumb-item active">New Calendar</li>
          </ol>
       </nav>
       <hr style="margin-top:-10px"/>
  
       <br/>
       <form @submit="formSubmit">

          <div v-for="(res ,index) in CalendarContent">
             <div class="row">
                <div class="col-md-3">
                   <div class="form-group">  
                      <label>Name:</label> 
                      <input v-model="res.name" class="form-control" required>
                   </div>
                </div>
                <div class="col-md-2">
                   <div class="form-group">  
                      <label>Date:</label>    
                      <input type="date" v-model="res.start" class="form-control" required>
                   </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                     <label>Sub Department</label>    
                     <select class="form-control" v-model="res.display" required>
                        <option value="0">Display All</option>
                        <option v-for="sub_department in sub_departments" :key="sub_department.id"  :value="sub_department.id">{{ sub_department.sub_department_name }}</option>
                     </select>
                  </div>
               </div>
               <div class="col-md-2">
                  <div class="form-group">
                     <label>Type:</label>    
                     <select class="form-control" v-model="res.type" required @change="selectedType(res,index)">
                        <option value="">-- Choose One --</option>
                        <option value="1">Critical Day</option>
                        <option value="2">Holidays</option>
                        <option value="3">Meeting</option>
                        <option value="4">Celebration</option>
                        <option value="5">Block off</option>
                        <option value="6">Company Party</option>
                        <option value="7">Rest Day</option>
                     </select>
                     <br>
                  </div>
               </div>
               <div class="col-md-2">
                  <div class="form-group">
                      <label>Holiday Type</label>    
                      <select class="form-control" v-model="res.h_type" :disabled="res.isDisabled">
                          <option value="">-- Choose One --</option>
                          <option value="1">Regular Holiday</option>
                          <option value="2">Special Holiday</option>
                      </select>
                  </div>
              </div>
            
              <div class="col-md-1">
                <!-- <div class="floater-point-event"> -->
                    <div class="form-group float-right">
                      <button @click.stop.prevent="add_form" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i></button>
                      <button @click.stop.prevent="delete_form(index)" class="btn btn-xs btn-primary"><i class="fa fa-minus"></i></button>
                    </div>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <button class="btn btn-info float-right"><i class="fa fa-save"></i>&nbsp;Create calendar event</button> <br/><br/><br/><br/>
       </form>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
import { IntegerPlusminus } from 'vue-integer-plusminus'
export default {
  components: {
    Card,
    IntegerPlusminus
  },
  data() {
    return {
      CalendarContent: [
        {
          name: "",
          start: "",
          type: "",
          h_type: "",
          display: {},
          isDisabled:true
        }
      ],
      sub_departments: [],
     
    };
  },
  mounted() {
    this.getSubdepartments()
  },
  methods: {

    selectedType(type,index){
      console.log(JSON.stringify(index))


        if(type[index] !== 2){
          this.CalendarContent.map(e => { 
                e.h_type = ""
                return e.isDisabled = false    
             }
          )
        }
        // if(type != 2){
        //   this.CalendarContent.map(e => { 
        //         e.h_type = ""
        //         return e.isDisabled = true    
        //      }
        //   )
        // }
    },

    getSubdepartments() {
      axios.get('api/subdepartments')
      .then(response => {
        this.sub_departments = response.data
      })
      .catch(error => {
        console.log(error.response)
      });
    },

    add_form: function() {
     
      // this.CalendarContent[index].isDisabled = !this.CalendarContent[index].isDisabled

      // console.log(this.CalendarContent[index].isDisabled)

      this.CalendarContent.push({
        name: "",
        start: "",
        type: "",
        h_type: "",
        display: {}
      });
    },
    delete_form: function(index) {
      this.CalendarContent.splice(index, 1);
      if (index === 0) this.add_form();
    },
    formSubmit(e) {
      e.preventDefault();
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to save",
        type: "warning",
        showCancelButton: true,
        showCloseButton: false
      }).then(isConfirm => {
        if (isConfirm === true) {

          console.log('response => calendar',JSON.stringify(this.CalendarContent))
          axios
            .post(
              "api/calendar/add",
              {
                calendar_content: JSON.stringify(this.CalendarContent)
              }
            )
            .then(resp => {
              this.$swal("Save", resp.data.success, "success");
              this.$router.push({
                name: "holidays"
              });
              this.clear_data();
            })
            .catch(error => {
              console.log("response => ", error.response.data);
            });
        } 
      });
      
      console.log(JSON.stringify(this.CalendarContent))
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-calendar/todo-add-calendar-event.vue